/**
 * State preservation system for hard reloads.
 * Saves in-progress work to localStorage so users can resume after a build update.
 */

const PREFIX = "perform_preserve_";
const RELOAD_FLAG = "perform_was_hard_reload";

// --- Generic helpers ---

export function preserveState<T>(key: string, data: T): void {
  try {
    localStorage.setItem(`${PREFIX}${key}`, JSON.stringify(data));
  } catch {
    // Storage full or unavailable — best effort
  }
}

export function restoreState<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(`${PREFIX}${key}`);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function clearPreserved(key: string): void {
  localStorage.removeItem(`${PREFIX}${key}`);
}

// --- Reload flag ---

export function markHardReload(): void {
  sessionStorage.setItem(RELOAD_FLAG, "1");
}

export function wasHardReload(): boolean {
  return sessionStorage.getItem(RELOAD_FLAG) === "1";
}

export function clearHardReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_FLAG);
}

// --- Keys ---
export const PRESERVE_KEYS = {
  ACTIVE_SESSION: "active_session",
  SESSION_CREATOR_MANUAL: "session_creator_manual",
  SESSION_CREATOR_AI: "session_creator_ai",
  PROGRAM_GENERATOR: "program_generator",
  MANUAL_PROGRAM_BUILDER: "manual_program_builder",
} as const;
